/* global globalThis */
const { prepareVoiceApplication } = require('./voiceApplication');

async function submitVoiceApplication(payload, fetcher = fetch) {
  const application = prepareVoiceApplication(payload);
  const fallback = {
    delivered: false,
    mailto: `mailto:kei@sugano.works?subject=${encodeURIComponent(application.subject)}&body=${encodeURIComponent(application.text)}`,
    applicationText: application.text,
    requiresQrAttachment: application.payment.method === 'paypay',
    message: 'フォームから送信できませんでした。入力内容を引き継いでメールで応募できます。下のボタンでメールアプリを開き、内容を確認して送信してください。',
  };
  let response;
  try {
    const body = JSON.stringify(payload);
    const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (globalThis.crypto?.subtle) {
      const hash = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(body));
      headers['x-amz-content-sha256'] = Array.from(new Uint8Array(hash), n => n.toString(16).padStart(2, '0')).join('');
    }
    response = await fetcher('/api/jobs/apply', {
      method: 'POST',
      headers,
      body,
    });
  } catch (_) { return fallback; }
  // Static hosting and proxy error pages can return HTML, including with status 200.
  if (!/\bapplication\/(?:[\w.-]+\+)?json\b/i.test(response.headers.get('content-type') || '')) return fallback;
  let result;
  try { result = await response.json(); } catch (_) { return fallback; }
  if (response.ok && result?.accepted === true && typeof result.applicationId === 'string') return { accepted: true, applicationId: result.applicationId };
  if (response.ok && result?.delivered === true) return { delivered: true };
  if (response.status === 400) throw new Error('入力内容を確認して、もう一度お試しください。');
  if (response.status === 413) throw new Error('添付画像が大きすぎます。1MB以下の画像を選んでください。');
  return fallback;
}
module.exports = { submitVoiceApplication };
